import { Injectable } from '@angular/core';
import { MtRolesRouting } from '../../models/mt-roles-routing';
import { MtToken } from '../../models/mt-token';
import { ModulTozsamosciService } from '../modul-tozsamosci-service/modul-tozsamosci.service';
import { RoleService } from '../role.service';

@Injectable({
  providedIn: 'root'
})
export class ModulTozsamosciAccessCheckerService {

  constructor(
    private mtService: ModulTozsamosciService,
    private readonly roleService: RoleService
  ) { }

  isAccessGranted(routeParams: MtRolesRouting): boolean {
    if (routeParams !== null && routeParams !== undefined) {
      const token: MtToken = this.mtService.getParsedToken();
      if (this.mtService.isAuthenticated()) {
        let realmGuard = false;
        if (routeParams.realm !== null && routeParams.realm !== undefined) {
          realmGuard = routeParams.realm.some(x => this.roleService.listRoles().includes(x));
          // TODO: Okres przejściowy - docelowo: resource_access
          // Do usunięcia
          if(realmGuard === false) {
            realmGuard = routeParams.realm.every(x => token.payload.realm_access.roles.includes(x));
          }
          // ---
        } else {
          realmGuard = true;
        }

        // resource roles
        let resourceRoles = false;
        if (routeParams.resources !== null && routeParams.resources !== undefined) {
          resourceRoles = Object.keys(routeParams.resources).every(x => {
            const roles = routeParams.resources[x];
            if (token.payload.resource_access[x]) {
              return roles.every(y => token.payload.resource_access[x].roles.includes(y));
            }
            return false;
          });
        } else {
          resourceRoles = true;
        }
        return realmGuard && resourceRoles;
      }
      return false;
    }
    return true;
  }
}
